// EXTERNAL IMPORTS
import React, { Component } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { connect } from "react-redux";
import { themr } from "react-css-themr";
// import { Switch, Route } from 'react-router-dom';
import { withRouter } from "react-router";
import { RadioTabs, Button, Link, Input } from "@lifepay/rc-ui-toolkit";

// ABSOLUTE PATH IMPORTS
// importing object with action creator functions
import actions from "model/actions";
// import selectors from "model/selectors";

import PersonSearchResults from "components/client-search/PersonSearchResults";
import CompanySearchResults from "components/client-search/CompanySearchResults";
import queryFactory, { searchClients } from "model/gql/queries";
// import mutationFactory, { blockCard } from "model/gql/mutations";

// RELATIVE PATH IMPORTS
// importing default component styles
import styles from "./ClientSearch.m.scss";

const ClientSearchData = queryFactory(searchClients);
// const BlockCardMutation = mutationFactory(blockCard);

@withRouter
// connecting component to the redux store
@connect(
  // mapStateToProps function - passes data from store's state.
  (state) => {
    return {};
  },
  // mapDispatchToProps object - pass individual action creators here
  {
    addClient: actions.clients.addClient,
    acceptInconmingCall: actions.clients.acceptInconmingCall,
    clientSearchPageEnter: actions.app.clientSearchPageEnter,
    clientSearchPageLeave: actions.app.clientSearchPageLeave,
  }
)
@themr("client-search", styles)
export default class ClientSearch extends Component {
  // declaring props passed to the component
  static propTypes = {
    theme: PropTypes.object,
    history: PropTypes.object,
    basePath: PropTypes.string,
    // action creators:
    addClient: PropTypes.func,
    acceptInconmingCall: PropTypes.func,
    clientSearchPageEnter: PropTypes.func,
    clientSearchPageLeave: PropTypes.func,
  };

  constructor(props) {
    super(props);

    this.state = {
      clientType: "PERSON",
      personSearchType: "FIO",
      companySearchType: "NAME",
      search: "",
      currentSearch: "",
      personSkip: true,
      companySkip: true,
    };
  }

  componentDidMount() {
    // this.props.clientSearchPageEnter();
  }

  componentWillUnmount() {
    // this.props.clientSearchPageLeave();
  }

  changeClientType = ({ value, id }) => {
    this.setState({ clientType: value });
  };

  personSearchType = ({ value, id }) => {
    this.setState({ personSearchType: value });
  };

  companySearchType = ({ value, id }) => {
    this.setState({ personSearchType: value });
  };

  handleChange = ({ value, id }) => {
    this.setState({ search: value });
  };

  startSearch = (event) => {
    event.preventDefault();

    let skipKey = null;
    switch (this.state.clientType) {
      case "PERSON": {
        skipKey = "personSkip";
        break;
      }
      case "COMPANY": {
        skipKey = "companySkip";
        break;
      }
    }
    this.setState({ currentSearch: this.state.search, [skipKey]: false });
  };

  workWithClient = ({ type, id }) => {
    const { addClient, history, basePath } = this.props;
    switch (type) {
      case "PERSON": {
        addClient({ type, remoteId: id });
        history.push(`${basePath}/p-${id}/menu`);
        break;
      }
      case "COMPANY": {
        addClient({ type, remoteId: id });
        history.push(`${basePath}/c-${id}/menu`);
        break;
      }
    }
  };

  renderSearchInput = () => {
    const { theme } = this.props;
    const {
      clientType,
      personSearchType,
      companySearchType,
      search,
    } = this.state;
    let searchInput = null;
    if (clientType === "PERSON") {
      switch (personSearchType) {
        case "FIO": {
          searchInput = (
            <Input
              controlled
              throttle={false}
              onChange={this.handleChange}
              value={search}
              theme={{
                label: theme.label,
              }}
            >
              {"Ф.И.О."}
            </Input>
          );
          break;
        }
        case "PHONE": {
          searchInput = (
            <Input
              controlled
              throttle={false}
              onChange={this.handleChange}
              value={search}
              theme={{
                label: theme.label,
              }}
            >
              {"Телефон"}
            </Input>
          );
          break;
        }
        case "PASSPORT": {
          searchInput = (
            <Input
              controlled
              throttle={false}
              onChange={this.handleChange}
              value={search}
              theme={{
                label: theme.label,
              }}
            >
              {"Номер и серия паспорта"}
            </Input>
          );
          break;
        }
      }
    } else if (clientType === "COMPANY") {
      switch (companySearchType) {
        case "NAME": {
          searchInput = (
            <Input
              controlled
              throttle={false}
              onChange={this.handleChange}
              value={search}
              theme={{
                label: theme.label,
              }}
            >
              {"Наименование компании"}
            </Input>
          );
          break;
        }
      }
    }
    return searchInput;
  };

  render() {
    const { theme } = this.props;
    const {
      clientType,
      currentSearch,
      personSearchType,
      personSkip,
      companySkip,
      search,
    } = this.state;

    let submitButtonType = "disabled";
    let submitButtonDisabled = true;
    if (search || clientType === "COMPANY") {
      submitButtonType = "alt";
      submitButtonDisabled = false;
    }

    return (
      <div className={classnames(theme.wrapper)}>
        <div className={classnames(theme.inner)}>
          <div className={classnames(theme.controls)}>
            <form
              onSubmit={submitButtonDisabled ? undefined : this.startSearch}
            >
              <div className={classnames(theme.row)}>
                <RadioTabs
                  id={"clientType"}
                  tabs={[
                    {
                      id: "PERSON",
                      component: "физ. лицо",
                    },
                    {
                      id: "COMPANY",
                      component: "юр. лицо",
                    },
                  ]}
                  value={clientType}
                  onChange={this.changeClientType}
                >
                  {"Тип клиента"}
                </RadioTabs>
                {clientType === "PERSON" ? (
                  <RadioTabs
                    id={"personSearchType"}
                    tabs={[
                      {
                        id: "FIO",
                        component: "Ф.И.О.",
                      },
                      {
                        id: "PHONE",
                        component: "Телефону",
                      },
                      {
                        id: "PASSPORT",
                        component: "Паспорту",
                      },
                    ]}
                    value={personSearchType}
                    onChange={this.personSearchType}
                  >
                    {"Искать по"}
                  </RadioTabs>
                ) : null}
              </div>
              <div className={classnames(theme.row)}>
                {this.renderSearchInput()}
              </div>
              <div className={classnames(theme.row, theme.action)}>
                <Button
                  type={submitButtonType}
                  disabled={submitButtonDisabled}
                  theme={{
                    wrapper: theme.button,
                  }}
                  onClick={this.startSearch}
                >
                  {"Искать"}
                </Button>
                <Link type="alt" to="/">
                  {"Вернуться"}
                </Link>
              </div>
            </form>
          </div>
          <ClientSearchData
            skip={clientType === "PERSON" ? personSkip : companySkip}
            searchType={clientType}
            searchBy={personSearchType}
            search={currentSearch}
          >
            {({ data, mutate }) => {
              switch (clientType) {
                case "PERSON":
                  return (
                    <PersonSearchResults
                      data={data}
                      workWithClient={this.workWithClient}
                    />
                  );
                case "COMPANY":
                  return (
                    <CompanySearchResults
                      data={data}
                      workWithClient={this.workWithClient}
                    />
                  );
                default:
                  return null;
              }
            }}
          </ClientSearchData>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Private/pages/workflow-client/ClientSearch/ClientSearch.js